import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './App.css';
import VehicleSection from './vehicle';
import Navbar from './navbar';
import Social from './social';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faYoutube, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faCar, faMapMarkerAlt, faTools, faPhone, faWallet, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FaUser } from 'react-icons/fa';

function App() {
  const [navbarBg, setNavbarBg] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', phone: '' });

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleWhatsApp = () => {
    const { name, phone } = formData;
    if (!name || !phone.match(/^\d{10}$/)) return;

    const message = `Hello, I am ${name}. My phone number is ${phone}. Please contact me regarding your services.`;
    const phoneNumber = '919905503825'; // Your WhatsApp number with country code
    const whatsappURL = `https://wa.me/919905503825?text=${encodeURIComponent(message)}`;

    window.open(whatsappURL, '_blank');
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavbarBg('bg-black');
      } else {
        setNavbarBg('');
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="App">
      <Navbar />

      <header
        id="home"
        className="relative bg-cover bg-center pt-20 h-[50vh] flex items-center justify-center text-center"
        style={{ backgroundImage: "url('/bg.jpg')" }}
      >
        <div className="container mx-auto text-white">
          <h1 className="text-5xl font-bold mb-4">Self Drive Car Ranchi</h1>
          <p className="text-lg mb-6">Experience Ranchi's Best Car Service</p>
          <Link
            to="footer"
            smooth={true}
            duration={500}
            className="bg-orange-600 text-white py-3 cursor-pointer px-6 rounded-lg hover:bg-orange-700 transition duration-300"
          >
            Book Now
          </Link>
        </div>
      </header>

      {/* Vehicle Features Section */}
      <div className="bg-black py-20">
        <section className="bg-black py-16">
          <div className="container mx-auto text-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
              <Feature icon={faCar} title="Well Maintained Cars" text="Ensuring top-notch quality and safety." />
              <Feature icon={faMapMarkerAlt} title="Pick and Drop" text="Convenient pick-up and drop-off services." />
              <Feature icon={faThumbsUp} title="Privacy and Freedom" text="Your journey, your rules." />
              <Feature icon={faTools} title="Well Serviced" text="Regular maintenance for smooth rides." />
              <Feature icon={faWallet} title="Affordable Rates" text="Competitive pricing without compromising quality." />
            </div>
          </div>
        </section>
      </div>

      <VehicleSection />
      <Social />

      {/* Get in Touch Section */}
      <section className="py-16 bg-black text-white" id="contact">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-orange-500 text-center mb-10">Get in Touch</h2>
          <div className="max-w-lg mx-auto bg-gray-900 border-2 border-orange-500 rounded-xl p-8 shadow-2xl">
            <div className="mb-6 relative">
              <label className="block text-sm font-semibold mb-2">Your Name</label>
              <div className="flex items-center">
                <FaUser className="absolute ml-3 text-orange-500" />
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="Enter Your Name"
                />
              </div>
            </div>

            <div className="mb-6 relative">
              <label className="block text-sm font-semibold mb-2">Phone Number</label>
              <div className="flex items-center">
                <faPhone className="absolute ml-3 text-orange-500" />
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  pattern="\d{10}"
                  required
                  className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="Enter Your Phone Number"
                />
              </div>
            </div>

            <button
              onClick={handleWhatsApp}
              className="w-full bg-orange-600 hover:bg-orange-700 text-white py-2 rounded-lg font-semibold transition duration-300"
            >
              Send via WhatsApp
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="footer" className="bg-black text-white py-8">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-4">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h2 className="text-lg underline font-semibold">Self Drive Car Ranchi</h2>
            <h3 className="text-sm">Providing diverse transportation solutions since 2009.</h3>
            <p>Self Drive Car in Ranchi provides diverse transportation solutions in Ranchi, Jharkhand.</p>
          </div>

          <div className="text-center md:text-left">
            <p className="text-lg underline font-semibold">Contact Us</p>
            <p className="mt-2">Nawa Toli, Kamla Kant Ln, near Pahadi Mandir, Ranchi, Jharkhand 834001</p>

            <div className="flex space-x-2 mb-4">
              <a
                href="tel:+919905503825"
                className="text-white hover:text-orange-600 flex items-center space-x-2"
                aria-label="Call us"
              >
                <FontAwesomeIcon icon={faPhone} size="lg" />
                <span className="text-gray-300 items-center ">+91 99055 03825</span>
              </a>
            </div>

            <div className="flex justify-center md:justify-start space-x-4 py-4 mt-4 md:mt-0">
              <a href="https://wa.me/919905503825" target="_blank" rel="noopener noreferrer" className="text-white hover:text-orange-600">
                <FontAwesomeIcon icon={faWhatsapp} size="lg" />
              </a>
              <a href="https://www.facebook.com/maatourstravelsrnc/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-orange-600">
                <FontAwesomeIcon icon={faFacebook} size="lg" />
              </a>
              <a href="https://www.instagram.com/maatourstravelsrnc/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-orange-600">
                <FontAwesomeIcon icon={faInstagram} size="lg" />
              </a>
              <a
    href="https://www.youtube.com/@maatourtravelsrnc"  // 🔁 Replace with your actual YouTube channel URL
    target="_blank"
    rel="noopener noreferrer"
    className="text-white hover:text-orange-600"
    aria-label="YouTube"
  >
    <FontAwesomeIcon icon={faYoutube} size="lg" />
  </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Reusable Feature component
const Feature = ({ icon, title, text }) => (
  <div className="flex flex-col items-center text-white">
    <FontAwesomeIcon icon={icon} size="3x" className="text-orange-500 mb-4" />
    <h3 className="text-xl font-semibold">{title}</h3>
    <p className="mt-2 text-gray-300">{text}</p>
  </div>
);

export default App;
